// src/components/layout/sidebar.data.ts
import React from 'react';
import { IconType } from 'react-icons';
import { FiHome, FiUsers, FiList, FiMapPin, FiPackage  } from 'react-icons/fi';
import { FaSearch, FaSearchPlus } from 'react-icons/fa';
import { ReactComponent as ReporteHistoricoIcon } from '../../assets/icons/reporte-historico.svg';

export interface MenuItemType {
  path: string;
  icon?: IconType;
  iconComponent?: React.FC<React.SVGProps<SVGSVGElement>>;
  name: string;
  children?: MenuItemType[];
}

export const menuItems: MenuItemType[] = [
  { path: '/inicio', icon: FiHome, name: 'Inicio' },
  { path: '/usuarios', icon: FiUsers, name: 'Usuarios' },
  { path: '/reporte-acetileno', icon: FaSearch, name: 'Reporte acetona' },
  { path: '/reporte-historico', iconComponent: ReporteHistoricoIcon, name: 'Reporte histórico' },
  { path: '/auditrail', icon: FaSearchPlus, name: 'Auditrail' },
  //{ path: '/maestro-envases', icon: FiList, name: 'Maestro envases' },
  {
    path: '/catalogos',
    icon: FiList,
    name: 'Catálogos',
    children: [
      { path: '/catalogos/sucursales-index', icon: FiMapPin, name: 'Sucursales' },
      { path: '/catalogos/tipo-envase-index', icon: FiPackage , name: 'Tipo envase' },
    ],
  },
  
];
